import * as ActionUtilsModule from './utils';
export function createAction(type, payload, meta) {
    const action = { type, payload, meta };
    return action;
}
export function createErrorAction(type, payload, meta) {
    const action = Object.assign(Object.assign({}, ActionUtilsModule.createAction(type, payload, meta)), { error: true });
    return action;
}
export function createThunkAction(type, payload, meta) {
    return ActionUtilsModule.createAction(type, payload, Object.assign({ thunk: true }, (meta && typeof meta === 'object' && !Array.isArray(meta) ? meta : {})));
}
